export default "__VITE_ASSET__DrrtCeiD__"